import React, { useEffect, useRef, useState } from "react";
import { array, bool, func, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { useMediaQuery } from "react-responsive";

import NavbarSearch from "../NavbarSearch";
import Navbar from "../Navbar";
import { getSocialLinks } from "../../utils/utils";
import Icon from "../../icons";
import { Facebook, Twitter, Email } from "../../atoms/icons/StoryPageIcons";
import Messenger from "../../atoms/icons/Messenger";
import LauncherIcon from "../../atoms/icons/LauncherIcon";
import WatsAppIcon from "../../atoms/icons/WatsAppIcon";
import DefaultMobileLogo from "../../atoms/icons/default-mobile-logo";
import VersionList from "../../atoms/VersionList";
import { staticTexts } from "../../utils/Translate";
import Youtube from "../../layouts/footer/DefaultFooter/Youtube";
import Instagram from "../../layouts/footer/KishoraloFooter/Instagram";
import { CloseIcon } from "../../basic/icons/close-icon";

import "./verticalMenubar.m.css";

const VerticalMenubar = ({
  isVerticalMenubar,
  isDesktop,
  toggleVerticalMenubar,
  hamburgerMenu,
  domainSlug = "",
  socialLinks,
  publisherAttributes
}) => {
  const [stickyHeader, setStickyHeader] = useState(false);
  const verticalMenubarClassName = isVerticalMenubar ? "vertical-menubar slide-in" : "vertical-menubar";
  const socialShareLinks = getSocialLinks(domainSlug, socialLinks);
  const ref = useRef(null);
  const isMobile = useMediaQuery({
    query: "(min-device-width: 864px)"
  });

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      toggleVerticalMenubar();
    }
  };

  useEffect(() => {
    const getIntersectionObsPoint = document.querySelectorAll("#intersection-obs")[0];
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          entry.intersectionRatio ? setStickyHeader(false) : setStickyHeader(true);
        });
      },
      {
        rootMargin: "10px"
      }
    );
    getIntersectionObsPoint && observer.observe(getIntersectionObsPoint);

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return (
    <div
      styleName={`vertical-menubar-wrapper ${isDesktop ? `fixed-wrapper` : ""} ${
        domainSlug && (domainSlug === "biggan-chinta" || domainSlug === "kishoralo" || domainSlug === "bigganchinta")
          ? "multi-domain"
          : ""
      } ${domainSlug && domainSlug === "nagorik-sangbad" ? "nagorik-vertical-menubar-wrapper" : ""}`}
      className="vertical-menubar-wrapper"
    >
      <div
        ref={ref}
        className="vertical-menubar"
        styleName={`${verticalMenubarClassName} ${
          domainSlug && domainSlug === "protichinta" ? "protichinta-ham" : ""
        } ${stickyHeader ? "sticky-vertical-menubar" : ""}`}
      >
        <div styleName="close" onClick={toggleVerticalMenubar}>
          {domainSlug === "nagorik-sangbad" ? (
            !isMobile ? (
              <Icon type="close" className="close" />
            ) : (
              <CloseIcon color="#ffffff" width="25" height="25" />
            )
          ) : (
            <Icon type="close" className="close" />
          )}
        </div>
        {!isDesktop && <NavbarSearch />}
        <Navbar menu={hamburgerMenu} isVerticalMenubar={true} toggleVerticalMenubar={toggleVerticalMenubar} />
        <div styleName="bottom-container">
          {!domainSlug && (
            <ul
              styleName={`version-list-wrapper ${publisherAttributes.lang === "en" ? "en-version-list-wrapper" : ""}`}
            >
              <p styleName={`version-text ${publisherAttributes.lang === "en" ? "en-version-text" : ""}`}>
                {staticTexts(publisherAttributes.lang).edition}
              </p>
              <VersionList />
            </ul>
          )}
          {domainSlug && (
            <div
              styleName={`prothomalo-logo ${
                domainSlug &&
                (domainSlug === "biggan-chinta" || domainSlug === "bigganchinta" || domainSlug === "kishoralo")
                  ? "no-logo"
                  : ""
              }`}
            >
              <DefaultMobileLogo width={165} height={38} />
            </div>
          )}
          <div
            styleName={` social-share-icons ${
              domainSlug &&
              (domainSlug === "biggan-chinta" || domainSlug === "bigganchinta" || domainSlug === "kishoralo")
                ? "no-logo-icons"
                : ""
            }`}
          >
            {socialShareLinks.fbUrl && (
              <Link href={socialShareLinks.fbUrl} target="_blank" rel="noopener noreferrer">
                <Facebook />
              </Link>
            )}
            {socialShareLinks.twitterUrl && (
              <Link href={socialShareLinks.twitterUrl} target="_blank" rel="noopener noreferrer">
                <Twitter />
              </Link>
            )}
            {socialShareLinks.messengerUrl && (
              <Link href={socialShareLinks.messengerUrl} target="_blank" rel="noopener noreferrer">
                <Messenger />
              </Link>
            )}
            {socialShareLinks.launcherUrl && (
              <Link href={socialShareLinks.launcherUrl} target="_blank" rel="noopener noreferrer">
                <LauncherIcon />
              </Link>
            )}
            {socialShareLinks.watsappUrl && (
              <Link href={socialShareLinks.watsappUrl} target="_blank" rel="noopener noreferrer">
                <WatsAppIcon />
              </Link>
            )}
            {socialShareLinks.emailUrl && (
              <Link href={socialShareLinks.emailUrl} target="_blank" rel="noopener noreferrer">
                <Email />
              </Link>
            )}
            {socialShareLinks.YouTubeUrl && (
              <Link
                href={socialShareLinks.YouTubeUrl}
                className="youtube-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Youtube />
              </Link>
            )}
            {socialShareLinks.InstagramUrl && (
              <Link href={socialShareLinks.InstagramUrl} target="_blank" rel="noopener noreferrer">
                <Instagram color1="#eee" color2="#121212" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

VerticalMenubar.propTypes = {
  isVerticalMenubar: bool,
  isDesktop: bool,
  toggleVerticalMenubar: func,
  node: func,
  hamburgerMenu: array,
  domainInfo: object,
  domainSlug: string,
  publisherAttributes: object,
  socialLinks: object
};

const mapStateToProps = state => ({
  domainSlug: get(state, ["qt", "domainSlug"]),
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
});

export default connect(mapStateToProps, null)(VerticalMenubar);
